import { getValueReduxUtil } from '../get-value'

export default function getClassNameReduxUtil (instance) {
  return (
    getValueReduxUtil(instance, 'className')
  )
}
